import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { BrokerPortalConfigurationState } from "../../types/broker-portal-config";
import { selectBrokerPortalConfigState } from "./broker-portal-config.slice";

export const useGetBrokerPortalConfigState = () => {
  return useSelector<AppStore, BrokerPortalConfigurationState>(
    selectBrokerPortalConfigState
  );
};
